import Settings from './defaultSettings';


const adminRoutes = [
  {
    key: 'admin_tenantview', // 添加唯一的 key
    path: '/admin/tenantview',
    name: '租户概览',
    icon: 'DashboardOutlined',
    component: './Dashboard/TenantDashboard',
    access: ['tenant_admin'],
    hideInMenu: false,
  },
  {
    key: 'admin_tenant', // 添加唯一的 key
    path: '/admin/tenant',
    name: '租户管理',
    icon: 'UsergroupAddOutlined',
    component: './Admin/TenantManagement',
    access: ['admin'],
    hideInMenu: false,
  },
  {
    key: 'admin_user', // 添加唯一的 key
    path: '/admin/user',
    name: '用户管理',
    icon: 'UserSwitchOutlined',
    component: './Admin/UserManagement',
    access: ['admin', 'tenant_admin'],
    hideInMenu: false,
  },
  {
    key: 'admin_role', // 添加唯一的 key
    path: '/admin/role',
    name: '角色管理',
    icon: 'ContactsOutlined',
    component: './Admin/RoleManagement',
    access: ['admin'],
    hideInMenu: false,
  },
  {
    key: 'admin_statistics', // 添加唯一的 key
    path: '/admin/statistics',
    name: '统计',
    icon: 'UserSwitchOutlined',
    component: './Dashboard/AdminDashboard',
    access: ['admin'],
    hideInMenu: false,
  },
  {
    key: 'admin_permission', // 添加唯一的 key
    path: '/admin/permission',
    name: '权限管理',
    icon: 'LockOutlined',
    component: './Admin/PermissionManagement',
    access: ['tenant_admin'],
    hideInMenu: false,
  },
  {
    key: 'admin_department', // 添加唯一的 key
    path: '/admin/department',
    name: '部门管理',
    icon: 'ApartmentOutlined',
    component: './Admin/DepartmentManagement',
    access: ['tenant_admin'],
    hideInMenu: false,
  },
  {
    key: 'admin_position', // 添加唯一的 key
    path: '/admin/positon',
    name: '岗位管理',
    icon: 'SolutionOutlined',
    component: './Admin/PositionManagement',
    access: ['tenant_admin'],
    hideInMenu: false,
  },
  //**************** system   系统管理员*************/
  {
    key: 'admin_cron', // 父菜单
    name: '定时任务',
    icon: 'ClockCircleOutlined',
    access: ['system'],
    hideInMenu: false,
    routes: [
      {
        key: 'admin_cron_manage',
        path: '/admin/cron',
        name: '任务管理',
        // icon: 'ClockCircleOutlined',
        component: './Admin/JobManagement',
        access: ['system'],
        hideInMenu: false,
      },
      {
        key: 'admin_joblog',
        path: '/admin/joblog',
        name: '任务日志',
        // icon: 'FileTextOutlined',
        component: './Admin/JobLog',
        access: ['system'],
        hideInMenu: false,
      },
    ],
  },
  {
    key: 'admin_ai', // 父菜单
    name: 'AI算法',
    icon: 'RobotOutlined',
    access: ['system'],
    hideInMenu: false,
    routes: [
      {
        key: 'admin_ai_category',
        path: '/admin/ai/category',
        name: '分类管理',
        component: './Admin/AI/AICategory',
        access: ['system'],
        hideInMenu: false,
      },
      {
        key: 'admin_ai_algorithm',
        path: '/admin/ai/algorithm',
        name: '算法管理',
        component: './Admin/AI/AIAlgorithm',
        access: ['system'],
        hideInMenu: false,
      },
      {
        key: 'admin_ai_algorithm_package',
        path: '/admin/ai/algorithmpackage',
        name: '算法组管理',
        component: './Admin/AI/AIAlgorithmPackage',
        access: ['system'],
        hideInMenu: false,
      },
    ],
  },
  {
    key: 'admin_onlineusers',
    path: '/admin/onlineusers', // 正确
    name: '在线用户',
    icon: 'TeamOutlined',
    component: './Admin/OnlineUsers', // 建议有独立的组件
    access: ['system'],
    hideInMenu: false,
  },
  {
    key: 'admin_feedback',
    name: '用户反馈',
    icon: 'MessageOutlined',
    path: '/admin/feedback',
    access: ['system'],
    component: './Admin/Feedback', // 反馈列表页面
    hideInMenu: false,
    routes: [
      {
        key: 'admin_feedback_detail',
        name: '反馈详情',
        path: '/admin/feedback/detail',
        component: './Admin/Feedback/detail',
        hideInMenu: true, // 不显示在菜单
      },
    ],
  },
  {
    key: 'admin_tasklog',
    path: '/admin/tasklog',
    name: '日志管理',
    icon: 'ClockCircleOutlined',
    component: './Admin/TaskLog',
    access: ['tenant_admin'],
    hideInMenu: false,
  },
  // {
  //   key: 'admin_menu', // 添加唯一的 key
  //   path: '/admin/menu',
  //   name: '菜单管理',
  //   icon: 'MenuOutlined',
  //   component: './Admin/MenuManagement',
  //   access: ['system'],  // 系统管理员权限
  //   hideInMenu: false,
  // },
  // {
  //   key: 'admin_dictionary', // 添加唯一的 key
  //   path: '/admin/dictionary',
  //   name: '字典管理',
  //   icon: 'ScheduleOutlined',
  //   component: './Admin/DictionaryManagement',
  //   access: ['system'],
  //   hideInMenu: false,
  // },
  /*-----------订单-------------*/

];

if(!Settings.isLocal){
  adminRoutes.push({
    key: 'user_project', // 添加唯一的 key
    path: '/admin/order',
    name: '产品授权',
    icon: 'ProjectOutlined',
    component: './Admin/Order',
    access: ['person'],  // 系统管理员权限
    hideInMenu: false,
  });
  adminRoutes.push(
  {
    key: 'user_order', // 添加唯一的 key
    path: '/admin/order/detail',
    name: '订单详情',
    icon: 'FundViewOutlined',
    component: './Admin/Order/OrderDetail',
    access: ['person'],  // 系统管理员权限
    hideInMenu: false,
  });
  adminRoutes.push(
  {
    key: 'admin_order', // 添加唯一的 key
    path: '/admin/order/manager',
    name: '订单管理',
    icon: 'FundViewOutlined',
    component: './Admin/Order/OrderManager',
    access: ['admin'],  // 系统管理员权限
    hideInMenu: false,
  })
}


export default adminRoutes;